<template src="./index.html"></template>
<script>
import { yhs_csh, yhs_fycx, stamp_uploadFile_api, dateclear } from '../../../../api/yhs.js';
import { getdata } from './data.js';
import mxdj from './mxdj/index.vue';
import config from '../../../../../configHttp.js';
import uploadFile from '../../../common/uploadFile/index.vue';
export default {
	name: 'yhs',
	components: {
		mxdj,
		uploadFile
	},
	data: function() {
		return {
			tablekey: 0,
			overlength: 0,
			searchdata: getdata().searchdata,
			searchlist: getdata().searchlist,
			outlist: [],
			headData: getdata().headData,
			pagination: getdata().pagination,
			tableData: [{}],
			shaidiag: false,
			searchdiag: false,
			hzdiag: false,
			suosq: this.$getdefultMonth(),
			filediag: false,
			upformdata: {},
			mxparams: {},
			//
			showmxdj: false,
			diagData: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
			czData: [{}, {}, {}]
		};
	},
	mounted() {},
	created() {
		this.init();
	},
	methods: {
		geOoverLength(e) {
			this.overlength = e;
		},
		remove(e) {
			this.$showConfirm({
				message: '清空数据后当前税款所属期间内未申报的所有数据将清除，是否确认操作？'
			}).then(res => {
				if (res == 'confirm') {
					let params = {
						suosq: this.suosq,
						id: e.id
					};
					dateclear(params).then(res => {
						if (res.data.code == 1) {
							this.init();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} 
			});
		},
		formxdj(e) {
			// if(e.suosqbz!=1){
			// 	return false
			// }
			this.mxparams = e;
			this.showmxdj = true;
		},
		downloadList() {
			let selectVal = this.$refs.tablebox.getSelectionval();
			let params = {
				pageShowListPojo: {}
			};
			if (selectVal.length < 1) {
				params.pageShowListPojo = JSON.parse(JSON.stringify(this.searchdata));
				params.pageShowListPojo.page = this.pagination.pageNum;
				params.pageShowListPojo.size = this.pagination.pageSize;
				params.pageShowListPojo.suosq = this.suosq;
			} else {
				let _ids = selectVal.map(item => item.id);
				params.ids = _ids;
			}
			params.json = getdata().tableJson;
			this.fileDownload(params);
		},
		fileDownload(val) {
			let params = {
				downUrl: config.baseURL + '/stamp/list/export',
				typeObj: {
					toForm: false,
					fileType: 'xlsx',
					fileName: '印花税数据' + this.$timestampToStr(new Date(), 'yyyyMMdd'),
					failUrl:this.$winURl
				},
				params: val
			};
			this.$downloadcommon(params);
		},
		//下载标准模板
		fordownloadmb() {
			//简单下载，交给浏览器去做处理
			let params = {
        downUrl: config.baseURL + "/stamp/dowloadTemplate",
				failUrl:config.baseURL + "/login",
        typeObj: {
						toForm: true,
						fileType: "xlsx",
					},
					params:{},
      	};
      	this.$downloadcommon(params)
		},
		getuploadparams(e) {
			//获取上传文件流
			this.upformdata = e;
		},
		showFileUpload() {
			this.upformdata = {
				upfilename: '',
				upfile: '',
				filestate: '',
				filetype: '',
				filesize: ''
			};
			this.filediag = true;
		},
		forupload() {
			if (this.$emptyandnull(this.upformdata.upfile)) {
				this.$message.error('请选择要上传的文件');
				return false;
			}
			let formData = {
				importType: '0',
				file: this.upformdata.upfile
			};
			stamp_uploadFile_api(formData).then(res => {
				if (res.data.code == 1) {
					if (res.data.data && res.data.data.errorCount > 0) {
						this.fordowloaderr(this.upformdata.filetype, res.data.data.batchNo);
					} else {
						this.$message.success(res.data.msg);
					}
					this.yhsQuery();
					this.filediag = false;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		fordowloaderr(filetype, batchNo) {
			let params = {
				downUrl: config.baseURL + '/upload-history/downloadErrorFile',
				typeObj: {
					toForm: true,
					fileType: filetype,
					failUrl:this.$winURl
				},
				params: {
					batchNo: batchNo
				}
			};
			this.$downloadcommon(params);
		},
		//初始化
		init() {
			yhs_csh().then(res => {
				if (res.data.code == 1) {
					this.suosq = this.$getdefultMonth(); //获取当前所属期yyyymm
                    this.searchdata.suosq =this.$getdefultMonth()
                    this.yhsQuery();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		//查询
		yhsQuery() {
			let params = JSON.parse(JSON.stringify(this.searchdata));
			params.current = this.pagination.pageNum;
			params.size = this.pagination.pageSize;
			params.sort = '';
			params.order = '';
			params.suosq = this.suosq;
			yhs_fycx(params).then(res => {
				if (res.data.code == 0) {
					this.$message.error(res.data.msg);
					return;
				} else {
					this.tableData = res.data.data.records;
					this.pagination.total = res.data.data.total;
				}
			});
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.yhsQuery();
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.yhsQuery();
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.yhsQuery();
		},
		suosqchange() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.yhsQuery();
		},
		forRefresh() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
		},
		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		confirmfilter(e) {
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
		},
		closeshaidiag() {
			this.shaidiag = false;
		},
		forback() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.yhsQuery();
			this.showmxdj = false;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
